import {_PROFILE_STATUS_CODE, _STATUS_CODE} from "./constant.js";
import {isElectron} from "../../util/electron/comm.js";
// import ioV4 from "socket.io-client";

export {
    //초기화
    initStatusSocket,

    //유저리스트 구독
    setConnectUserList,

    //내 상태 제어
    updateMyState
}

let statusSocket = null;
let myState = null;
const initState = {
    'user': {
        USE_INTT_ID: window._USE_INTT_ID,
        USER_ID: window._USER_ID,
    }
}


async function initStatusSocket() {
    if (!Mutil.isFunc('USE_STATUS_SERVER_V2') || !isElectron()) return;
    if (!window._STATUS_URL) return;

    if (await connectSocket()) receiveStatusSocket();
    $("#profileState").attr('data-user-id', window._USER_ID)
}

//즉시실행함수 영역에서 호출됨
function updateMyState(updateData, isOnlineInit) {
    if (!updateData || !statusSocket || !isElectron()) return;
    if (myState?.STATUS === updateData?.STATUS) {
        return Mutil.clog('이미 같은 상태입니다.')
    }
    statusSocket.emit("update-status", {...initState.user, ...updateData});
}

//즉시실행함수 영역에서 호출됨
function setConnectUserList(props) {
    const {
        emptyAll = false, //모든 리스트 초기화 여부
        subscribeList = [], //구독 추가할 유저 리스트
        leaveList = [], //구독 제거할 유저 리스트
    } = props

    if (emptyAll) removeAllUser()
    if (subscribeList.length > 0) getUsers(subscribeList)
    if (leaveList.length > 0) removeUsers(leaveList);
}

async function connectSocket() {
    if (statusSocket || !isElectron()) return false;

    const ioV4 = await import('socket.io-client');
    statusSocket = ioV4.connect(window._STATUS_URL, {
        rememberUpgrade: true,
        query: {
            "token": window._JSESSION_ID
        }
    });
    statusSocket.emit("connect-status", initState);
    Mutil.clog('status socket connect')
    return true;
}

function getUsers(subscribeList) {
    if(!statusSocket) return;

    statusSocket.emit("list-status", {
        ...initState,
        'data': subscribeList
    });
}

function removeUsers(list) {
    if(!statusSocket) return;

    statusSocket.emit("list-unsubscribe", list);
}

function removeAllUser() {
    if(!statusSocket) return;

    statusSocket.emit("leave-all-unsubscribe");
}

function receiveStatusSocket() {
    if (!Mutil.isFunc('USE_STATUS_SERVER_V2') || !isElectron()) return;
    if (!statusSocket) return;

    statusSocket.on("get-list-status", (resultList) => {
        resultList.map(v => {
            changeTargetItems({
                userId: v.USER_ID,
                status: _PROFILE_STATUS_CODE[v.STATUS]
            })
        })
    })

    statusSocket.on("receive-status", (result) => {
        const userId = result.UUID.split('_')[2];
        changeTargetItems({
            userId,
            status: _PROFILE_STATUS_CODE[result.STATUS]
        })
        if (userId === window._USER_ID) {
            myState = result;
        }
    })

    statusSocket.on("reconnect", () => {
        updateMyState({
            STATUS: _STATUS_CODE.ONLINE
        });
    })
}

function changeTargetItems({userId, status = 'offline'}) {
    if (Mutil.n2v(userId) === "") return;

    const targetItems = $(`.js-user-state[data-user-id='${userId}']`)
    targetItems.removeClass('mini-mode-online mini-mode-out mini-mode-business mini-mode-offline')
        .addClass(`mini-mode-${status}`)
}
